import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WrapContent = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Wrap = styled.div`
  position: relative;
  display: flex;
  gap: 5px;
`;

export const Split = styled.div`
  border: 1px solid #000;
  border-radius: 5px;
  color: #000;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  :nth-child(6),
  :nth-child(7),
  :nth-child(8) {
    border-color: red;
  }

  @media (max-width: 768px) {
    width: 25px;
    height: 25px;
  }
`;

export const Input = styled.input`
  position: absolute;
  border: none;
  text-align: center;
  background-color: transparent;
  outline: none;
  width: 32px;
  top: 0px;
  bottom: 0px;

  @media (max-width: 768px) {
    width: 25px;
  }
`;

export const Error = styled.p`
  color: red;
  font-size: 16px;
  line-height: 1;
  margin-top: 10px;
  display: flex;
  align-items: center;

  svg {
    margin-left: 5px;
    fill: red;
    font-size: 20px;
  }
`;
